import { Component, Input, inject } from '@angular/core';
import { UtilService } from '../../../../services/util.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatorService } from '../../../../services/translator_service';

@Component({
  selector: 'app-billing-summary-header',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './billing-summary-header.component.html',
  styleUrl: './billing-summary-header.component.scss'
})
export class BillingSummaryHeaderComponent {

  private _data: any[] = [];
  currentLang;

  constructor(private translator: TranslatorService, private utilService: UtilService) {
    this.currentLang = this.translator.translate.currentLang || 'en';
    this.translator.currentLangEmitter$.subscribe((lang: any) => {
      this.currentLang = lang;
    });
  }

  @Input() set data(value: any[]) {
    this._data = value;
  }
  get data(): any[] { return this._data; }

  get isHebrew(): boolean { return this.currentLang == 'iw'; }

  get totalChargeableUnits(): number {
    return this._data.reduce((sum, contract) => sum + (contract.current_num_of_chargeable_units || 0), 0);
  }

  get newInstalledUnits(): number {
    let count = 0;
    for (const contract of this._data) {
      for (const site of (contract.sites || [])) {
        for (const bin of (site.bins || [])) {
          for (const event of (bin.events || [])) {
            if (event.contracts_events_type_id == 3) count++;
          }
        }
      }
    }
    return count;
  }

  get overallBilling(): string {
    let total = 0;
    for (const contract of this._data) {
      for (const site of (contract.sites || [])) {
        for (const bin of (site.bins || [])) {
          for (const event of (bin.events || [])) {
            total += event.rate || 0;
          }
        }
      }
    }
    const firstEt = this._data.flatMap((c: any) => c.event_types || []).find((et: any) => et);
    const currency = firstEt ? (this.isHebrew ? firstEt.contract_currency_type_name_hebrew : firstEt.contract_currency_type_name) : '';
    return `${this.utilService.roundAmount(total)} ${currency}`.trim();
  }
}
